import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

//Tables
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTable from '../utils/MyTable';

//Utils
import { applyMaskAccount, applyMaskAmount } from '../utils/utils';

import { useDispatch } from "react-redux";
import UnoButton from '../utils/UnoButton';

import { Checkbox, Typography } from '@material-ui/core';

import CircularProgress from '@material-ui/core/CircularProgress';
import { myLabelInput, tabs, unoTheme } from '../../assets/styles/unoTheme';

import moment from 'moment';
import allActions from '../../actions';
import { AssetsAPI } from '../../API/assets';
import { MyTab, MyTabs } from '../utils/MyTabs';
import { AccountAPI } from '../../API/account';
// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        //alignItems: 'center',
        paddingBottom: theme.spacing(2),
    },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    actionsFlexRight: {
        display: 'flex',
        alignItems: 'center',
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },
    formControl: {
        //margin: theme.spacing(1), 
        width: '100%',
        textAlign: 'left'
    },
    dialogTitle: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between'
        }

    },
    noMarginTop: {
        marginTop: "0px",
    },
    tableTh: {
        fontWeight: 'bold'
    },
    assetsToCreateRow: {
        '& .MuiTableCell-root': {
            fontSize: '12px !important',
        }
    },
    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    blue: {
        color: "blue",
    },
    warningColor: {
        color: unoTheme.warningColor
    },
    label: myLabelInput,
    afirmativeText: {
        color: 'black'
    },
    noPaddingLeft: {
        paddingLeft: '0px',
    },
    noPaddingRight: {
        paddingRight: '0px !important',
    },

    progress: {
        color: unoTheme.mainColor,
        textAlign: 'center',
        height: "100%",
        display: "flex",
        alignItems: 'center',
        justifyContent: "center",
        '& .MuiCircularProgress-root': {
            width: '25px !important',
            height: '25px !important',
        },

        '& h6': {
            fontSize: '14px !important',
        }
    },

    labelTopModal: {
        float: 'right',
        fontSize: '14px',
        color: unoTheme.defaultTextColor
    },

    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },

    ellipsis: {
        whiteSpace: "nowrap", /* Impede a quebra de linha */
        overflow: "hidden", /* Garante que o texto extra seja ocultado */
        textOverflow: "ellipsis",
    },


}));

export default function UpdateAssetsInitsModal(props) {

    const dispatch = useDispatch();
    const history = useHistory();
    const classes = useStyles();

    const { open, client, oldInitPortfolio, newInitPortfolio,
        handleClose, handleAction } = props;

    const [loader, setLoader] = useState("");

    const [tabValue, setTabValue] = useState(0);
    const handleChangeTabValue = (event, newValue) => {
        setTabValue(newValue);
    };

    const [assetsToUpdate, setAssetsToUpdate] = useState([]);
    const [assetsTitlesToUpdate, setAssetsTitlesToUpdate] = useState([]);
    const [accountsToUpdate, setAccountsToUpdate] = useState([]);

    const handleCheckAssetTransation = (event, index) => {

        const newCheckeds = [...assetsToUpdate]
        newCheckeds[index].toUpdate = event.target.checked;
        setAssetsToUpdate(newCheckeds);
    }

    const handleCheckAssetTitleTransation = (event, index) => {

        const newCheckeds = [...assetsTitlesToUpdate]
        newCheckeds[index].toUpdate = event.target.checked;
        setAssetsTitlesToUpdate(newCheckeds);
    }

    const handleCheckAccount = (event, index) => {

        const newCheckeds = [...accountsToUpdate]
        newCheckeds[index].toUpdate = event.target.checked;
        setAccountsToUpdate(newCheckeds);
    }

    const loadInfos = async () => {

        setLoader("Carregando informações...");
        //Carregando ativos de fundos com a mesma referenceDate
        const resposeAssetsByInit = await AssetsAPI.getFundAssetsByInit(client.id, moment.utc(oldInitPortfolio).format("DD/MM/YYYY"));
        if (resposeAssetsByInit.success) {
            setAssetsToUpdate(resposeAssetsByInit.body.rows.map(el => ({
                ...el, toUpdate: true,
            })))
        }

        const resposeAssetsTitlesByInit = await AssetsAPI.getTitlesAssetsByInit(client.id, moment.utc(oldInitPortfolio).format("DD/MM/YYYY"));
        if (resposeAssetsTitlesByInit.success) {
            setAssetsTitlesToUpdate(resposeAssetsTitlesByInit.body.rows.map(el => ({
                ...el, toUpdate: true,
            })))
        }

        const resposeAccountsByInit = await AccountAPI.getAccountsByInit(client.id, moment.utc(oldInitPortfolio).format("DD/MM/YYYY"));
        if (resposeAccountsByInit.success) {
            setAccountsToUpdate(resposeAccountsByInit.body.rows.map(el => ({
                ...el, toUpdate: true,
            })))
        }

        setLoader("");
    }

    async function doUpdate(e, assetsFunds, assetsTitles, accounts) {

        setLoader("Atualizando inícios dos ativos e contas...");

        const newInit = moment.utc(newInitPortfolio).format("DD/MM/YYYY");
        //Atualizando ativos de fundos
        const filteredAssets = assetsFunds.filter(el => el.toUpdate);
        for (let index = 0; index < filteredAssets.length; index++) {
            const element = filteredAssets[index];
            await AssetsAPI.updateFundAssetInit(element.id, newInit);
        }

        //Atualizando ativos de títulos
        const filteredAssetsTitles = assetsTitles.filter(el => el.toUpdate);
        for (let index = 0; index < filteredAssetsTitles.length; index++) {
            const element = filteredAssetsTitles[index];
            await AssetsAPI.updateTitleAssetInit(element.id, newInit);
        }

        //Atualizando contas
        const filteredAccounts = accounts.filter(el => el.toUpdate);
        for (let index = 0; index < filteredAccounts.length; index++) {
            const element = filteredAccounts[index];
            await AccountAPI.updateAccountInit(element.id, newInit);
        }

        setLoader(false);
        handleAction(e, true);

    }

    useEffect(() => {
        if (!open) return;
        loadInfos();
    }, [open])

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            PaperProps={{
                style: {
                    height: '90vh', // 80% da altura da viewport
                },
            }}
            onClose={() => handleClose()}>
            <DialogTitle
                className={classes.dialogTitle}>
                {
                    oldInitPortfolio && newInitPortfolio &&

                    <span>Ativos a serem atualizados - <span style={{ color: unoTheme.redMoney }}>{moment.utc(oldInitPortfolio).format("MM/YYYY")}</span> para <span style={{ color: unoTheme.greenMoney }}>{moment.utc(newInitPortfolio).format("MM/YYYY")}</span></span>

                }

            </DialogTitle>

            <DialogContent
                className={classes.contentModal}>

                {
                    loader ?
                        <div className={classes.progress}>
                            <CircularProgress
                                disableShrink color="inherit" />
                            <Typography variant={"h6"}>
                                {loader}
                            </Typography>
                        </div>
                        :
                        <>

                            <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: "auto" }}>

                                <MyTabs
                                    value={tabValue}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    onChange={handleChangeTabValue}>

                                    <MyTab label={`Fundos [${assetsToUpdate?.length}]`} />
                                    <MyTab label={`Títulos [${assetsTitlesToUpdate?.length}]`} />
                                    <MyTab label={`Contas [${accountsToUpdate?.length}]`} />

                                </MyTabs>

                            </div>
                            <div style={{ height: "calc(100% - 72px)" }}>

                                {
                                    tabValue === 0 &&
                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">

                                        <colgroup>
                                            <col width="5%" />
                                            <col width="35%" />
                                        </colgroup>

                                        <TableHead>
                                            <TableRow>

                                                <TableCell align="center" className='noPaddingCell'>
                                                </TableCell>
                                                <TableCell className={classes.tableTh} align="left">Fundo</TableCell>
                                                <TableCell className={classes.tableTh} align="center">CC</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Ag.</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Início</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {
                                                //content.data.transactions.map((row, index) => (
                                                assetsToUpdate && assetsToUpdate.map((row, index) => (


                                                    <TableRow className={classes.detailRow}
                                                        key={'assets-to-update-' + index}>

                                                        <TableCell align="center" className='noPaddingCell'>
                                                            <Checkbox
                                                                checked={row.toUpdate === true}
                                                                color="primary"
                                                                onClick={(e) => e.stopPropagation()}
                                                                onChange={(e) => {
                                                                    handleCheckAssetTransation(e, index)
                                                                }}
                                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="left" className={classes.ellipsis}>{row.fund_name}</TableCell>
                                                        <TableCell align="center">{row.number_account ? applyMaskAccount(row.number_account) : ""}</TableCell>
                                                        <TableCell align="center">{row.agency ?? "-"}.</TableCell>
                                                        <TableCell align="center" style={{ color: "blue" }}>{moment.utc(row.asset_init).format("MM/YYYY")}</TableCell>

                                                    </TableRow>

                                                ))

                                            }
                                        </TableBody>

                                    </MyTable>
                                }

                                {
                                    tabValue === 1 &&
                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">

                                        <colgroup>
                                            <col width="5%" />
                                            <col width="35%" />
                                        </colgroup>

                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={classes.tableTh} align="center"></TableCell>
                                                <TableCell className={classes.tableTh} align="left">Título</TableCell>
                                                <TableCell className={classes.tableTh} align="center">CC</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Ag.</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Início</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {
                                                //content.data.transactions.map((row, index) => (
                                                assetsTitlesToUpdate && assetsTitlesToUpdate.map((row, index) => (


                                                    <TableRow className={classes.detailRow}
                                                        key={'assets-titles-to-update-' + index}>

                                                        <TableCell align="center" className='noPaddingCell'>
                                                            <Checkbox
                                                                checked={row.toUpdate === true}
                                                                color="primary"
                                                                onClick={(e) => e.stopPropagation()}
                                                                onChange={(e) => {
                                                                    handleCheckAssetTitleTransation(e, index)
                                                                }}
                                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="left" className={classes.ellipsis}>{row.title_name}</TableCell>
                                                        <TableCell align="center">{row.number_account ? applyMaskAccount(row.number_account) : ""}</TableCell>
                                                        <TableCell align="center">{row.agency ?? "-"}.</TableCell>
                                                        <TableCell align="center" style={{ color: "blue" }}>{moment.utc(row.asset_title_init).format("MM/YYYY")}</TableCell>

                                                    </TableRow>

                                                ))

                                            }
                                        </TableBody>

                                    </MyTable>
                                }

                                {
                                    tabValue === 2 &&
                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">

                                        <colgroup>
                                            <col width="5%" />
                                            <col width="35%" />
                                        </colgroup>

                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={classes.tableTh} align="center"></TableCell>
                                                <TableCell className={classes.tableTh} align="left">Instituição</TableCell>
                                                <TableCell className={classes.tableTh} align="center">CC</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Ag.</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Início</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {
                                                //content.data.transactions.map((row, index) => (
                                                accountsToUpdate && accountsToUpdate.map((row, index) => (


                                                    <TableRow className={classes.detailRow}
                                                        key={'accounts-to-update-' + index}>

                                                        <TableCell align="center" className='noPaddingCell'>
                                                            <Checkbox
                                                                checked={row.toUpdate === true}
                                                                color="primary"
                                                                onClick={(e) => e.stopPropagation()}
                                                                onChange={(e) => {
                                                                    handleCheckAccount(e, index)
                                                                }}
                                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="left">{row.description}</TableCell>
                                                        <TableCell align="center">{row.number_account ? applyMaskAccount(row.number_account) : ""}</TableCell>
                                                        <TableCell align="center">{row.agency ?? "-"}.</TableCell>
                                                        <TableCell align="center" style={{ color: "blue" }}>{moment.utc(row.account_init).format("MM/YYYY")}</TableCell>

                                                    </TableRow>

                                                ))

                                            }
                                        </TableBody>

                                    </MyTable>
                                }
                            </div>


                        </>
                }


            </DialogContent>


            {
                !loader ?
                    <>

                        <DialogActions className={classes.actionsFlex}>

                            <div style={{ flex: 1 }}>

                                <UnoButton onClick={() =>
                                    handleClose()} color="secondary">
                                    {'Cancelar'}
                                </UnoButton>
                            </div>

                            <UnoButton
                                className={classes.spaceRight2}
                                onClick={(e) => handleAction(e, false)}
                                color="primary">
                                {'Não atualizar'}
                            </UnoButton>
                            <UnoButton
                                className={classes.spaceRight2}
                                onClick={(e) => doUpdate(e, assetsToUpdate, assetsTitlesToUpdate, accountsToUpdate)}
                                type="success">
                                {'Atualizar'}
                            </UnoButton>

                        </DialogActions>

                    </>
                    : null

            }




        </Dialog >
    );
}